import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'radio',
	template: `
		<div [formGroup]="form">
			<div class="form-check" *ngFor="let opt of field.options">
				<input class="form-check-input" type="radio" [value]="opt.key" #radioButtonContainer /> <label class="form-check-label"> {{ opt.label }} </label>
			</div>
		</div>
	`
})
export class FLXRadioComponent {
	@ViewChild('radioButtonContainer', { static: true }) radioButtonContainer: ElementRef;

	@Input() field: any = {};	@Input()
	set disabled(disabled: boolean) {
		this.radioButtonContainer.nativeElement.disabled = disabled;
	}
	get disabled() {
		return this.radioButtonContainer.nativeElement.disabled;
	}
	@Input() form: UntypedFormGroup;
}
